import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../index";
import axios from "axios";
import { getAuthToken } from "../../utils/utils";

// Async thunk to fetch programs
export const getTution = createAsyncThunk(
  "tuition/getTuition",
  async (userId, thunkAPI) => {
    try {
      const token = getAuthToken();

      const response = await axios.get(baseUrl + `/tuition-income/${userId}`, {
        params: { userId },

        headers: {
          Authorization: `${token}`, // Pass the token here
          "Content-Type": "application/json", // Make sure the content type is correct
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const tuitionSlice = createSlice({
  name: "tuition",
  initialState: {
    tuitionIncome: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTution.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTution.fulfilled, (state, action) => {
        state.loading = false;
        state.tuitionIncome = action.payload;
      })
      .addCase(getTution.rejected, (state, action) => {
        state.loading = false;
        state.tuitionIncome = [];
        state.error = action.payload;
      });
  },
});

export default tuitionSlice.reducer;
